import { Modal } from 'antd';
import React, { useState } from 'react';
import ForgotPasswordForm from './ForgotPasswordForm';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';

const AuthModal = ({ visible, onClose, defaultTab = 'login' }) => {
  const [currentForm, setCurrentForm] = useState(defaultTab);

  const handleClose = () => {
    setCurrentForm('login'); // 重置到登录页面
    onClose();
  };

  const renderCurrentForm = () => {
    switch (currentForm) {
      case 'register':
        return (
          <RegisterForm
            onSwitchToLogin={() => setCurrentForm('login')}
            onClose={handleClose}
          />
        );
      case 'forgot':
        return (
          <ForgotPasswordForm
            onSwitchToLogin={() => setCurrentForm('login')}
            onClose={handleClose}
          />
        );
      case 'login':
      default:
        return (
          <LoginForm
            onSwitchToRegister={() => setCurrentForm('register')}
            onSwitchToForgotPassword={() => setCurrentForm('forgot')}
            onClose={handleClose}
          />
        );
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={handleClose}
      footer={null}
      centered
      width={480}
      destroyOnClose
      maskClosable={false}
      className="auth-modal"
    >
      {renderCurrentForm()}
    </Modal>
  );
};

export default AuthModal; 